import {
  CalculateLeasingRewardsQuery,
  CalculateLeasingRewardsResponse,
} from "@swarm/shared/schemas";
import {
  CalculateUnlockedRewardsQuery,
  CalculateUnlockedRewardsResponse,
} from "@swarm/shared/schemas";
import { ClaimDailyRewardsRequest } from "@swarm/shared/schemas";
import { GetClaimsByUserAddressQuery, GetClaimsByUserAddressResponse } from "@swarm/shared/schemas";
import { ClaimLeasingRewardsRequest } from "@swarm/shared/schemas";
import { ScheduleClaimRequest } from "@swarm/shared/schemas";
import { ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";
import { z } from "zod";

export const ClaimDailyRewardsFormSchema = z.object({
  amount: z
    .string({
      error: "Amount cannot be empty.",
    })
    .regex(/^\d*\.?\d+$/, "Amount must be a valid number")
    .refine((val) => {
      const [, decimals] = (val || "").split(".");

      return !decimals || decimals.length <= 8;
    }, "Amount must have at most 8 decimal places")
    .refine((val) => parseFloat(val) >= 10, "Amount must be at least 10"),
});

export type ClaimsContextControllerProps = {
  children: ReactNode;
};

export type ClaimsContextType = {
  calculateUnlockedRewardsResponse?: CalculateUnlockedRewardsResponse;
  getClaimsByUserAddressResponse?: GetClaimsByUserAddressResponse;
  claimDailyRewards: (args: ClaimDailyRewardsRequest) => Promise<void>;
  scheduleClaimRewards: (args: ScheduleClaimRequest) => Promise<void>;
  claimLeasingRewards: (args: ClaimLeasingRewardsRequest) => Promise<void>;
  calculateUnlockedRewards: (args: CalculateUnlockedRewardsQuery) => Promise<void>;
  calculateLeasingRewards: (
    args: CalculateLeasingRewardsQuery,
  ) => Promise<CalculateLeasingRewardsResponse | undefined>;
  getClaimsByUserAddress: (args: GetClaimsByUserAddressQuery) => Promise<void>;
  isRewardsCardLoading: boolean;
  hasScheduledClaim: boolean;
  claimDailyRewardsForm: UseFormReturn<z.infer<typeof ClaimDailyRewardsFormSchema>>;
};
